import { Component, Inject, OnInit, Optional } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from "@angular/material/dialog";
import { AuthService } from "../../auth/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-tutorial-modal",
  templateUrl: "./tutorial-modal.component.html",
  styleUrls: ["./tutorial-modal.component.scss"],
  standalone: false,
})
export class TutorialModalComponent implements OnInit {
  videoUrl!: SafeResourceUrl;

  constructor(
    private dialog: MatDialog,
    private auth: AuthService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Record<string, unknown>,
    @Optional() public dialogRef: MatDialogRef<TutorialModalComponent>,
  ) {}

  async ngOnInit(): Promise<void> {
    const lang = this.translate.currentLang || "en";
    const videoId =
      lang === "es"
        ? "L9LbwE3yI_c"
        : lang === "pl"
          ? "rb4e9cFCddM"
          : "uL6aGrEuJ-s";
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube-nocookie.com/embed/${videoId}`,
    );

    await this.auth.fetchCurrent();

    if (
      !this.dialogRef &&
      !this.auth.lastGoogleSync &&
      this.auth.dataSource !== "LOCAL" &&
      !this.auth.isSuperAdmin
    ) {
      this.dialog.open(TutorialModalComponent, {
        width: "800px",
        maxWidth: "92vw",
        disableClose: true,
        panelClass: "app-dialog-panel",
        data: {},
      });
    }
  }

  close(): void {
    this.dialogRef?.close();
  }
}
